<template>
    <div class="bg-main-background-color">
        <AppHeader/>
        <article class="start-page">
            <transition :name="confirm ? 'right' : 'left'" mode="out-in">
                <StartConfirm v-if="confirm"
                              :request="request"
                              :payment="payment"
                              :is-processing="isProcessing"
                              :price="price"
                              :client-secret="clientSecret"
                              :order-id="orderId"
                              @cancel="onCancel"
                              @submit="onSubmit"/>
                <div v-else-if="!confirm">
                    <FormHeader/>
                    <ShowStep :current="1"/>
                    <form @submit.prevent="onSubmitCocolink" v-if="!idInput">
                        <SectionLabel>ココシンク情報</SectionLabel>
                        <CocoLinkForm
                            v-model="request.cocolink_id"
                            :errors="errors"
                        />
                    </form>
                    <form @submit.prevent="onConfirm" v-if="idInput">
                        <SectionLabel>お客様情報</SectionLabel>
                        <section class="content">
                            <FormConfirm label="ココシンクID" :value="request.cocolink_id" v-if="request.cocolink_id"/>
                            <div class="form-group">
                                <FormLabel :required="true">お名前</FormLabel>
                                <div class="flex flex-row">
                                    <div class="flex-1/2 pr-2">
                                        <FormInput type="text" class="w-full" autocomplete="family-name"
                                                   placeholder="山田" v-model="request.name1"/>
                                        <ErrorText name="name1" :errors="errors"/>
                                    </div>
                                    <div class="flex-1/2 pl-2">
                                        <FormInput type="text" class="w-full" autocomplete="given-name"
                                                   placeholder="太郎" v-model="request.name2"/>
                                        <ErrorText name="name2" :errors="errors"/>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <FormLabel :required="true">フリガナ</FormLabel>
                                <div class="flex flex-row">
                                    <div class="flex-1/2 pr-2">
                                        <FormInput type="text" class="w-full" placeholder="ヤマダ"
                                                   v-model="request.kana1"/>
                                        <ErrorText name="kana1" :errors="errors"/>
                                    </div>
                                    <div class="flex-1/2 pl-2">
                                        <FormInput type="text" class="w-full" placeholder="タロウ"
                                                   v-model="request.kana2"/>
                                        <ErrorText name="kana2" :errors="errors"/>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <FormLabel :required="true">郵便番号</FormLabel>
                                <div class="flex flex-row">
                                    <FormInput type="text" v-model="request.postcode" class="w-1/4"
                                               autocomplete="postal-code" size="7" :half-width="true" placeholder="例）104-0061"/>
                                    <button type="button" class="bg-gray-500 text-white ml-4 pl-2 pr-2 rounded"
                                            @click="onAddressSuggest">
                                        郵便番号検索
                                    </button>
                                </div>
                                <ErrorText name="postcode" :errors="errors"/>
                            </div>
                            <PrefPicker v-model="request.pref" :errors="errors"/>
                            <FormGroup name="city" label="市区町村" autocomplete="address-level2"
                                       v-model="request.city" :errors="errors"
                                       placeholder="○○市○○区"
                                       :required="true"/>
                            <FormGroup name="address" label="それ以降の住所" autocomplete="address-line1"
                                       v-model="request.address" :errors="errors"
                                       placeholder="○○町1丁目1-1"
                                       :required="true"/>
                            <FormGroup name="bill" label="マンション・建物名など（任意）" autocomplete="address-line2"
                                       v-model="request.bill" :errors="errors"/>
                            <FormGroup name="birthday" label="生年月日" class="w-1/4" autocomplete="birthday"
                                       type="date" :required="true"
                                       v-model="request.birthday" :errors="errors"/>
                            <div class="form-group">
                                <FormLabel :required="true">電話番号</FormLabel>
                                <FormInput v-model="request.tel" class="w-1/4" autocomplete="tel"
                                           placeholder="例）09012345678" :half-width="true"/>
                                <ErrorText name="tel" :errors="errors"/>
                                <p class="text-main-color text-sm mt-2">※ハイフン（-）無しで入力してください</p>
                            </div>
                            <div class="form-group">
                                <FormLabel :required="true">メールアドレス</FormLabel>
                                <FormInput type="email" class="w-full" autocomplete="email"
                                           v-model="request.email" placeholder="info@example.com"/>
                                <ErrorText name="email" :errors="errors"/>
                                <p class="text-sm mt-2">
                                    ※入力ミスや受信拒否設定をされている場合は、当協会からのメールが届きません。<br/>
                                    ※申込後の自動返信メールが届かない場合は協会までお問い合わせください。<br/>
                                    ※携帯メールアドレスをご使用の場合、届かない可能性があります。 <br/>
                                    必ず@regist.jhma.or.jpからのメールが受信できるように設定してください。<br/>
                                </p>
                            </div>
                            <div class="form-group">
                                <FormLabel :required="true">メールアドレス（確認用）</FormLabel>
                                <FormInput type="email" class="w-full" autocomplete="email"
                                    placeholder="info@example.com"
                                    v-model="request.email_confirm"/>
                                <ErrorText name="email_confirm" :errors="errors"/>
                            </div>
                            <div class="pl-2">
                                <FormLabel :required="true">職種</FormLabel>
                            </div>
                            <IndustryForm v-model="request.industry" :errors="errors"/>
                            <PaymentForm :request="request" :payment="payment"
                                        :errors="errors" :card-error="cardError"/>
                            <div v-if="request.payment_type === 'gmo'">
                                <div class="p-2">
                                    申し込み後、書類に請求書を同梱して発送いたします。
                                </div>
                            </div>
                            <div v-if="request.payment_type === 'bank'">
                                <div class="p-2">
                                    申し込み後、ご入力いただいたメールアドレスに振込先をお伝えいたします。<br/>
                                    当協会の振込確認後、正式に申し込み完了となります。<br/>
                                    恐縮ですがお振り込み手数料はご負担いただきますようお願い申し上げます。
                                </div>
                            </div>
                        </section>
                        <SectionLabel>お申し込み詳細</SectionLabel>
                        <section class="content">
                            <ApplyDetailTable :price="price" :is-selected="!!request.payment_type"/>
                            <p class="p-2">
                                <ErrorText :errors="errors" name="device_info"/>
                            </p>
                            <div v-if="paymentErrorMessage" class="payment-error-message p-4 mb-4 bg-red-100 border border-red-400 text-red-700 rounded">
                            <p class="font-bold">決済エラー</p>
                            <p>{{ paymentErrorMessage }}</p>
                        </div>
                        <div class="form-group w-[50%] mx-auto">
                            <button class="submit-button mx-auto" :disabled="isProcessing">内容確認</button>
                        </div>
                        </section>
                    </form>
                </div>
            </transition>
            <input type="hidden" id="fraudbuster" name="fraudbuster" ref="deviceInfo"/>
            <Loading :is-show="isProcessing"/>
        </article>
    </div>
</template>

<script>
import SectionLabel from "../../parts/app/SectionLabel";
import FormGroup from "../../parts/app/FormGroup";
import FormLabel from "../../parts/app/FormLabel";
import FormInput from "../../parts/app/FormInput";
import yubinbango from "../../mixins/yubinbango";
import multiPayment from "../../mixins/multiPayment";
import CardExpireInput from "../../parts/app/CardExpireInput";
import moment from "moment";
import StartConfirm from "../../parts/app/StartConfirm";
import ApplyDetailTable from "../../parts/app/ApplyDetailTable";
import {mapActions, mapState} from "vuex";
import ErrorText from "../../parts/ErrorText";
import SecurityCodeInformation from "../../parts/app/SecurityCodeInformation";
import BrandLogos from "../../parts/app/BrandLogos";
import IndustryForm from "../../parts/app/IndustryForm";
import PaymentForm from "../../parts/app/PaymentForm";
import TriggerForm from "../../parts/app/TriggerForm";
import FormHeader from "../../parts/app/FormHeader";
import Agreement from "../../parts/app/Agreement";
import PrefPicker from "../../parts/app/PrefPicker";
import Loading from "../../parts/app/Loading";
import CocoLinkForm from "../../parts/app/CocoLinkForm.vue";
import FormConfirm from "../../parts/app/FormConfirm.vue";
import AppFooter from "../../parts/app/AppFooter.vue";
import AppHeader from "../../parts/app/AppHeader.vue";
import RightBanner from "../../parts/app/RightBanner.vue";
import ShowStep from "../../parts/app/ShowStep";
import NarrowFooter from "../../parts/app/NarrowFooter";
import { loadStripe } from "@stripe/stripe-js";
import { saveFormData, loadFormData, clearPaymentError, loadPaymentError } from "../../utils/formDataCookie";

export default {
    name: "Start",
    components: {
        RightBanner,
        AppHeader,
        AppFooter,
        FormConfirm,
        CocoLinkForm,
        Loading,
        PrefPicker,
        Agreement,
        FormHeader,
        TriggerForm,
        IndustryForm,
        PaymentForm,
        BrandLogos,
        SecurityCodeInformation,
        ErrorText,
        ShowStep,
        NarrowFooter,
        ApplyDetailTable, StartConfirm, CardExpireInput, FormInput, FormLabel, FormGroup, SectionLabel
    },
    mixins: [yubinbango, multiPayment],
    head: {
        title: {
            inner: '在宅看護指導士認定登録申し込み',
            separator: '|',
            complement: '一般社団法人全国在宅医療マネジメント協会'
        },
        meta: [
            {
                name: 'stripe-content-security-policy',
                content: "frame-src 'self' https://*.stripe.com https://*.stripe.network;"
            }
        ],
        script: [
            {
                type: 'text/javascript',
                src: 'https://fraud-buster.appspot.com/js/fraudbuster.js'
            },
        ]
    },

    data() {
        return {
            request: {
                name1: '',
                name2: '',
                kana1: '',
                kana2: '',
                postcode: '',
                pref: null,
                city: '',
                address: '',
                bill: '',
                birthday: '',
                tel: '',
                email: '',
                email_confirm: '',
                industry: null,
                trigger: [],
                payment_type: "credit",
                pay_times: 1,
                agreement: true,
                cocolink_id: '',
                stripe_intent_id: null,
            },
            payment: {
                credit: {
                    cardno: '',
                    expire: moment().format('YYYYMM'),
                    securitycode: '',
                    holdername: ''
                },
                creditResult: {
                    token: null,
                    toBeExpiredAt: null,
                    maskedCardNo: null,
                    isSecurityCodeSet: null,
                }
            },
            confirm: false,
            // cocolink 廃止により ID 入力ステップをスキップしてお客様情報フォームを直接表示する。
            // 復旧時は false に戻す。詳細は docs/unlink_cocolink/README.md
            idInput: true,
            stripe: null,
            elements: null,
            card: null,
            cardError: '',
            loading: false,
            isProcessing: false,
            suppressConfirmWatcher: false, // Apple Pay/Google Pay処理中にwatcherのconfirm制御を抑制
            orderId: null,  // Store order ID for confirmation screen
            clientSecret: null,  // Store client secret for payment execution
            paymentErrorMessage: '',  // 3DS決済エラーメッセージ
            errors: {}
        }
    },

    computed: {
        ...mapState('price_get', {
            price: 'data',
        }),

        ...mapState('create_intent', {
            legacyClientSecret: state => state.data ? state.data.client_secret : null,
            intentOrderId: state => state.data ? state.data.order_id : null,
        })
    },

    watch: {
        'request.postcode': function (postcode, old) {
            if (!/^\d{0,3}-?\d{0,4}$/.test(postcode)) {
                this.$nextTick(() => {
                    this.request.postcode = old;
                });
            }
        },

        'request.tel': function (tel, old) {
            if (!/^\d*$/.test(tel)) {
                this.$nextTick(() => {
                    this.request.tel = old;
                });
            }
        },

        confirm: function (newVal, oldVal) {
            window.scrollTo({
                top: 0,
            });
            // 確認画面から入力画面に戻った場合、クレジットカード選択時のみStripe Elementsを再初期化
            // apple_pay / google_pay の場合は Payment Element を使用しないため不要
            if (oldVal === true && newVal === false && this.request.payment_type === 'stripe') {
                this.$nextTick(async () => {
                    // 少し待ってからElementsを再初期化
                    await new Promise(resolve => setTimeout(resolve, 200));
                    await this.initializeStripe();
                });
            }
        },

        "$store.state.apply_validate.requestStatus": function (status) {
            if (status === 'success') {
                // Apple Pay/Google Pay処理中はwatcherからconfirmを変更しない
                if (this.suppressConfirmWatcher) {
                    this.resetStatus();
                    return;
                }
                // エラーがない場合のみ確認画面に遷移
                const errors = this.$store.state.apply_validate.errors;

                if (!errors || Object.keys(errors).length === 0) {
                    this.resetStatus();
                    this.confirm = true;
                } else {
                    this.resetStatus();
                    // エラーがある場合は確認画面に遷移しない
                    this.confirm = false;
                }
            } else if (status === 'failed') {
                this.resetStatus();
                this.confirm = false;
                this.$toastr.error('入力をご確認ください。');
            }
        },

        "$store.state.apply_exec.requestStatus": function (status) {
            if (status === 'success') {
                this.resetExecStatus();
                this.$router.replace('/thank_you');
            } else if (status === 'failed') {
                this.resetExecStatus();
                this.confirm = false;
                this.$toastr.error('登録が行えませんでした。');
            }
        },

        "$store.state.apply_validate.errors": function (errors) {
            this.errors = errors;
        },

        "$store.state.apply_exec.errors": function (errors) {
            this.errors = errors;
            if (errors['payment_type']) {
                setTimeout(() => {
                    this.$scrollTo(`#error_payment_type`, {
                        offset: -80
                    });
                }, 500);
            }
        },

        "request.payment_type": async function (payment_type) {
            try {
                if (payment_type) {
                    // 選択された支払い方法に対応する価格を取得
                    await this.getPrice(payment_type);

                    if (payment_type === 'stripe') {
                        // クレジットカード選択時のみ Payment Element を初期化
                        // DOM更新を待ってからStripe初期化
                        await this.$nextTick();
                        // 少し遅延を入れてDOM要素が確実に表示されるのを待つ
                        setTimeout(async () => {
                            await this.initializeStripe();
                        }, 200);
                    }
                    // apple_pay / google_pay の場合は Payment Element を初期化しない
                }
            } catch (e) {
                this.$toastr.error('価格を取得できませんでした。');
            }
        }
    },

    beforeDestroy() {
        if (this.card && !this.isProcessing) {
            try {
                this.card.unmount();
            } catch (e) {
                console.warn(e);
            }
        }
    },

    mounted() {
        // Cookieからフォームデータを復元（3DS失敗時のリダイレクト用）
        const savedFormData = loadFormData();
        if (savedFormData) {
            // カード情報以外を復元
            Object.keys(savedFormData).forEach(key => {
                if (this.request.hasOwnProperty(key)) {
                    this.request[key] = savedFormData[key];
                }
            });
        }

        // 決済エラーメッセージを復元
        const paymentError = loadPaymentError();
        if (paymentError) {
            this.paymentErrorMessage = paymentError;
            clearPaymentError(); // 一度表示したらクリア
        }
    },

    methods: {
        ...mapActions('create_intent', [
            'createIntent'
        ]),
        ...mapActions('apply_validate', [
            'execValidate',
            'resetStatus',
            'clearErrors',
        ]),
        ...mapActions('apply_exec', [
            'execApply',
            'resetExecStatus',
        ]),
        ...mapActions('apply_pre', [
            'execPreApply',
        ]),
        ...mapActions('apply_confirm', [
            'execConfirmApply',
        ]),
        ...mapActions('price_get', [
            'getPrice',
        ]),
        // create_intent reinstated for initial Stripe PaymentIntent retrieval

        onCancel() {
            this.confirm = false;
        },

        async initializeStripe() {
            try {
                // payment_typeがstripeでない場合は初期化しない
                if (this.request.payment_type !== 'stripe') {
                    return;
                }

                // 既存のElementsのクリーンアップ
                if (this.card) {
                    try {
                        this.card.unmount();
                    } catch (e) {
                        console.warn(e);
                    }
                    this.card = null;
                }

                if (this.elements) {
                    try {
                        // Elementsがマウントされている場合は全て削除
                        const paymentElement = document.getElementById('payment-element');
                        if (paymentElement) {
                            paymentElement.innerHTML = '';
                        }
                    } catch (e) {
                        console.warn(e);
                    }
                    this.elements = null;
                }

                // Stripe初期化（公開鍵のみ）
                this.stripe = await loadStripe(process.env.MIX_STRIPE_KEY);
                if (!this.stripe) {
                    this.$toastr.error('Stripeライブラリの読み込みに失敗しました。');
                    return;
                }

                // Elements作成（client_secret不要でカード情報入力のみ）
                const appearance = {
                    theme: 'stripe',
                };

                // setupモードでElementsを作成（PaymentIntentなしでカード情報のみ収集）
                this.elements = this.stripe.elements({
                    mode: 'setup',
                    currency: 'jpy',
                    appearance,
                    paymentMethodCreation: 'manual' // createPaymentMethodを手動で呼び出すために必要
                });
                this.card = this.elements.create('payment', {
                    hidePostalCode: true,
                    layout: {
                        type: "accordion",
                        defaultCollapsed: false,
                        radios: 'auto',
                        spacedAccordionItems: true,
                    },
                    fields: {
                        billingDetails: "never",
                    },
                    wallets: {
                        applePay: 'never',
                        googlePay: 'never',
                        link: 'never',
                    },
                });

                // DOM要素が存在することを確認（複数回試行）
                let paymentElement = null;
                let retryCount = 0;
                const maxRetries = 20; // 最大試行回数を増加

                while (!paymentElement && retryCount < maxRetries) {
                    retryCount++;

                    // Vueの更新サイクルを待つ
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, 100));

                    // 複数の方法で要素を探す
                    paymentElement = this.$refs.paymentElement ||
                                   document.getElementById('payment-element') ||
                                   document.querySelector('#payment-element') ||
                                   document.querySelector('[ref="paymentElement"]');

                    // 要素が見つかったが非表示の場合
                    if (paymentElement) {
                        const isVisible = paymentElement.offsetParent !== null;
                        const hasDisplay = window.getComputedStyle(paymentElement).display !== 'none';

                        if (!isVisible || !hasDisplay) {
                            // 強制的に表示
                            paymentElement.style.display = 'block';
                            paymentElement.style.visibility = 'visible';
                            // 少し待ってから再チェック
                            await new Promise(resolve => setTimeout(resolve, 100));
                            const newIsVisible = paymentElement.offsetParent !== null;
                            if (!newIsVisible) {
                                paymentElement = null;
                            }
                        }
                    }
                }

                if (!paymentElement) {
                    this.$toastr.error('決済フォームの表示に失敗しました。ページを再読み込みしてください。');
                    return;
                }

                // マウント前に既存の子要素をクリア
                if (paymentElement.firstChild) {
                    paymentElement.innerHTML = '';
                }

                this.card.mount(paymentElement);
                this.card.on('change', (e) => {
                    this.cardError = e.error ? e.error.message : '';
                });

                // マウント後の確認
                await new Promise(resolve => setTimeout(resolve, 100));
                if (!paymentElement.firstChild) {
                    this.$toastr.error('決済フォームの表示に失敗しました。ページを再読み込みしてください。');
                }
            } catch (e) {
                console.error('Stripe初期化エラー:', e);
                this.$toastr.error('決済情報の初期化に失敗しました。');
            }
        },

        async onAddressSuggest() {
            const result = await this.resolvePostCode(this.request.postcode);
            this.request = {
                ...this.request,
                pref: result['region'],
                city: result['locality'],
                address: `${result['street']} ${result['extended']}`
            };
        },

        async parseCard() {
            if (this.request.payment_type === 'credit') {
                try {
                    const result = await this.getCardToken(this.payment.credit);
                    this.payment.creditResult = result;
                    return result['token'];
                } catch (e) {
                    this.$toastr.error(e.message);
                    this.confirm = false;
                    return undefined;
                }
            } else {
                return undefined;
            }
        },

        async onConfirm() {
            this.isProcessing = true;
            try {
                if (this.request.payment_type === 'stripe') {

                    // 1. Stripeシステムの初期化確認
                    if (!this.stripe || !this.elements || !this.card) {
                        this.$toastr.error('決済システムが初期化されていません。ページを再読み込みしてください。');
                        return;
                    }

                    // 2. DOM要素の確認
                    const paymentElement = this.$refs.paymentElement ||
                                         document.getElementById('payment-element');
                    if (!paymentElement?.firstChild) {
                        this.$toastr.error('決済フォームが正しく表示されていません。ページを再読み込みしてください。');
                        return;
                    }

                    // 3. 仮登録API（PaymentIntent作成のみ、決済は実行しない）
                    const deviceInfo = this.$refs.deviceInfo?.value || navigator.userAgent || 'unknown';

                    // 4. elements.submit()を実行してカード情報を確定
                    const {error: submitError} = await this.elements.submit();
                    if (submitError) {
                        this.$toastr.error(submitError.message);
                        return;
                    }

                    // 5. PaymentMethodを作成
                    const {error: paymentMethodError, paymentMethod} = await this.stripe.createPaymentMethod({
                        elements: this.elements,
                        params: {
                            billing_details: {
                                name: `${this.request.name1} ${this.request.name2}`,
                                email: this.request.email,
                                phone: this.request.tel,
                                address: {
                                    postal_code: this.request.postcode,
                                    state: this.request.pref,
                                    city: this.request.city,
                                    line1: this.request.address,
                                    line2: this.request.bill,
                                    country: 'JP'
                                }
                            }
                        }
                    });

                    if (paymentMethodError) {
                        this.$toastr.error(paymentMethodError.message);
                        return;
                    }

                    // 6. PaymentMethodを含めて仮登録API呼び出し
                    const preApplyResult = await this.execPreApply({
                        ...this.request,
                        payment_method_id: paymentMethod.id,
                        device_info: deviceInfo,
                    });
                    const orderId = preApplyResult?.order_id;
                    const clientSecret = preApplyResult?.client_secret;
                    if (!preApplyResult) {
                        this.$toastr.error('申込仮登録に失敗しました。入力内容を確認してください。');
                        return;
                    }
                    if (!orderId || !clientSecret) {
                        this.$toastr.error('申込仮登録に失敗しました。');
                        return;
                    }

                    // orderIdとclientSecretを保存（決済は実行しない）
                    this.orderId = orderId;
                    this.clientSecret = clientSecret;

                } else if (this.request.payment_type === 'apple_pay' || this.request.payment_type === 'google_pay') {
                    // ─── Apple Pay / Google Pay の場合 ───
                    // watcher による confirm 制御を抑制（execPreApply 完了後に手動で confirm=true にする）
                    this.suppressConfirmWatcher = true;

                    const deviceInfo = this.$refs.deviceInfo?.value || navigator.userAgent || 'unknown';

                    // 1. バリデーション実行
                    await this.execValidate({
                        ...this.request,
                        device_info: deviceInfo,
                    });

                    // バリデーション結果をチェック
                    if (this.$store.state.apply_validate.errors && Object.keys(this.$store.state.apply_validate.errors).length > 0) {
                        this.$toastr.error('入力内容にエラーがあります。確認してください。');
                        this.suppressConfirmWatcher = false;
                        return;
                    }

                    // 2. PaymentIntent作成（全顧客情報をmetadataに含める）
                    const preApplyResult = await this.execPreApply({
                        ...this.request,
                        device_info: deviceInfo,
                    });

                    if (!preApplyResult || !preApplyResult.order_id || !preApplyResult.client_secret) {
                        this.$toastr.error('決済情報の準備に失敗しました。');
                        this.suppressConfirmWatcher = false;
                        return;
                    }

                    this.orderId = preApplyResult.order_id;
                    this.clientSecret = preApplyResult.client_secret;
                    this.suppressConfirmWatcher = false;
                } else {
                    // 非Stripe決済の場合は従来通りバリデーションのみ
                    const deviceInfo = this.$refs.deviceInfo?.value || navigator.userAgent || 'unknown';
                    await this.execValidate({
                        ...this.request,
                        card_token: await this.parseCard(),
                        device_info: deviceInfo,
                    });

                    // バリデーション結果をチェック
                    if (this.$store.state.apply_validate.errors && Object.keys(this.$store.state.apply_validate.errors).length > 0) {
                        this.$toastr.error('入力内容にエラーがあります。確認してください。');
                        return; // エラーがある場合は確認画面に遷移しない
                    }
                }

                // フォームデータをCookieに保存（3DS失敗時の復元用）
                saveFormData(this.request);

                this.confirm = true;

            } catch (error) {
                // 422エラー（バリデーションエラー）の場合
                if (error.response?.status === 422) {
                    this.handleValidationErrors(error.response.data.errors);
                } else {
                    // その他のエラー
                    this.$toastr.error('処理中にエラーが発生しました。');
                }

                // エラーの場合は確認画面に遷移させない
                this.confirm = false;

            } finally {
                this.isProcessing = false;
            }
        },

        async onSubmit() {
            if (!this.confirm) {
                this.$toastr.error('無効な操作です。');
                return;
            }
            this.isProcessing = true;
            try {
                if (this.request.payment_type === 'stripe') {

                    // 必要な情報の確認
                    if (!this.orderId) {
                        this.$toastr.error('注文情報が見つかりません。最初からやり直してください。');
                        return;
                    }

                    if (!this.clientSecret) {
                        this.$toastr.error('決済情報が見つかりません。最初からやり直してください。');
                        return;
                    }

                    // Stripe Elementsが存在することを確認
                    if (!this.stripe || !this.elements) {
                        this.$toastr.error('決済システムが利用できません。入力画面に戻ってやり直してください。');
                        this.confirm = false;
                        return;
                    }

                    // Stripe決済実行
                    let currentIntent = null; // PaymentIntentを外側のスコープで宣言

                    // まずPaymentIntentの状態を確認
                    try {
                        const intentResponse = await this.stripe.retrievePaymentIntent(this.clientSecret);
                        currentIntent = intentResponse.paymentIntent;

                        if (currentIntent.status === 'succeeded') {
                            this.request.stripe_intent_id = currentIntent.id;

                            // 最終申込確認API（決済完了済み）
                            const deviceInfo = this.$refs.deviceInfo?.value || navigator.userAgent || 'unknown';
                            const confirmResult = await this.execConfirmApply({
                                ...this.request,
                                order_id: this.orderId,
                                stripe_intent_id: this.request.stripe_intent_id,
                                device_info: deviceInfo,
                            });

                            if (confirmResult?.success) {
                                this.$router.replace('/thank_you');
                            } else {
                                this.$toastr.error('申込確定に失敗しました。');
                            }
                            return;
                        }

                        if (currentIntent.status === 'canceled') {
                            this.$toastr.error('決済がキャンセルされています。最初からやり直してください。');
                            this.confirm = false;
                            return;
                        }

                        if (currentIntent.status !== 'requires_confirmation' && currentIntent.status !== 'requires_action') {
                            if (currentIntent.status === 'requires_payment_method') {
                                this.$toastr.error('カード情報に問題があります。入力画面に戻って再度カード情報を入力してください。');
                                this.confirm = false;
                                // カード情報をリセット
                                this.clientSecret = null;
                                this.orderId = null;
                                return;
                            } else {
                                this.$toastr.error('決済状態が正しくありません。最初からやり直してください。');
                                this.confirm = false;
                                return;
                            }
                        }
                    } catch (retrieveError) {
                        this.$toastr.error('決済状態の確認に失敗しました。');
                        return;
                    }

                    // manual + PaymentMethod既紐付けの場合、Stripe SDKではなくREST APIで確認
                    try {
                        // PaymentIntent確認をサーバーサイドで実行
                        const deviceInfo = this.$refs.deviceInfo?.value || navigator.userAgent || 'unknown';

                        // currentIntentが存在しない場合はエラー
                        if (!currentIntent || !currentIntent.id) {
                            this.$toastr.error('決済情報の取得に失敗しました。');
                            this.confirm = false;
                            return;
                        }

                        // currentIntentのIDを使用してstripe_intent_idを明示的に設定
                        const requestData = {
                            ...this.request,
                            order_id: this.orderId,
                            stripe_intent_id: currentIntent.id, // PaymentIntent IDを明示的に設定
                            device_info: deviceInfo,
                        };

                        const confirmResult = await this.execConfirmApply(requestData);

                        // 3Dセキュア認証が必要な場合
                        if (confirmResult?.requires_action || confirmResult?.requires_3ds_client_action) {
                            const threeDSClientSecret = confirmResult.client_secret;
                            if (!threeDSClientSecret) {
                                this.$toastr.error('3Dセキュア認証情報が不足しています。');
                                this.confirm = false;
                                return;
                            }

                            // Stripeオブジェクトの確認
                            if (!this.stripe) {
                                this.$toastr.error('決済システムが利用できません。');
                                this.confirm = false;
                                return;
                            }

                            // handleNextActionで3DS認証を実行
                            const { paymentIntent, error: threeDSError } = await this.stripe.handleNextAction({
                                clientSecret: threeDSClientSecret
                            });

                            if (threeDSError) {
                                this.$toastr.error(`3Dセキュア認証に失敗しました: ${threeDSError.message}`);
                                this.confirm = false;
                                return;
                            }

                            // 3DS認証後のPaymentIntentステータスを確認
                            // confirmation_method: 'manual'の場合、3DS認証後はrequires_confirmationになる
                            if (paymentIntent.status === 'succeeded' || paymentIntent.status === 'requires_confirmation') {
                                this.request.stripe_intent_id = paymentIntent.id;

                                // 3DS認証完了後、再度confirmを呼び出して本登録（サーバーサイドで最終確認）
                                try {
                                    const finalConfirmResult = await this.execConfirmApply({
                                        ...this.request,
                                        order_id: this.orderId,
                                        stripe_intent_id: paymentIntent.id,
                                        device_info: deviceInfo,
                                    });

                                    // 再度3DS認証が必要になることはないはずだが念のためチェック
                                    if (finalConfirmResult?.requires_action || finalConfirmResult?.requires_3ds_client_action) {
                                        this.$toastr.error('決済処理中にエラーが発生しました。');
                                        this.confirm = false;
                                        return;
                                    }

                                    if (finalConfirmResult?.success) {
                                        this.$router.replace('/thank_you');
                                    } else {
                                        this.$toastr.error('申込確定に失敗しました。');
                                        this.confirm = false;
                                    }
                                } catch (finalConfirmError) {
                                    this.$toastr.error('3Dセキュア認証後の申込確定に失敗しました。');
                                    this.confirm = false;
                                }
                                return;
                            } else if (paymentIntent.status === 'requires_payment_method') {
                                this.$toastr.error('3Dセキュア認証がキャンセルされました。再度お試しください。');
                                this.confirm = false;
                                return;
                            } else {
                                this.$toastr.error('決済処理中に問題が発生しました。');
                                this.confirm = false;
                                return;
                            }
                        }

                        if (confirmResult?.success) {
                            this.request.stripe_intent_id = confirmResult.stripe_intent_id;
                            this.$router.replace('/thank_you');
                        } else {
                            this.$toastr.error('決済確認に失敗しました。');
                            this.confirm = false;
                        }
                        return;

                    } catch (confirmError) {
                        // 422エラー（決済失敗）の場合
                        if (confirmError.response?.status === 422) {
                            const errorData = confirmError.response.data;

                            if (errorData.message === 'payment_failed') {
                                this.$toastr.error(`カード決済に失敗しました。${errorData.error || 'カード情報を確認してください。'}`);
                            } else if (errorData.message === 'payment_not_completed') {
                                this.$toastr.error('決済が完了していません。');
                            } else if (errorData.message === '3ds_failed' || errorData.message === '3ds_authentication_failed') {
                                this.$toastr.error(`3Dセキュア認証に失敗しました。${errorData.error || '別のカードをお試しください。'}`);
                            } else if (errorData.message === '3ds_action_required_no_secret') {
                                this.$toastr.error('3Dセキュア認証情報の取得に失敗しました。再度お試しください。');
                            } else {
                                this.$toastr.error(errorData.error || '決済処理でエラーが発生しました。');
                            }
                        } else {
                            this.$toastr.error('決済確認中にエラーが発生しました。');
                        }
                        this.confirm = false;
                        return;
                    }
                } else {
                    // 後払い・クレジットの場合は従来通りexecApplyを使用
                    const deviceInfo = this.$refs.deviceInfo?.value || navigator.userAgent || 'unknown';
                    await this.execApply({
                        ...this.request,
                        card_token: await this.parseCard(),
                        device_info: deviceInfo,
                    });
                }
            } catch (error) {
                this.$toastr.error('申込処理でエラーが発生しました。');
            } finally {
                this.isProcessing = false;
            }
        },

        handleValidationErrors(errors) {
            // Store the errors for display
            this.errors = errors;

            // Show toastr for general validation error
            this.$toastr.error('入力内容にエラーがあります。ご確認ください。');

            // Find the first error field and scroll to it
            const firstErrorField = Object.keys(errors)[0];
            if (firstErrorField) {
                setTimeout(() => {
                    const errorElement = document.querySelector(`#error_${firstErrorField}`) ||
                                       document.querySelector(`[name="${firstErrorField}"]`) ||
                                       document.querySelector(`#${firstErrorField}`);

                    if (errorElement) {
                        this.$scrollTo(errorElement, {
                            offset: -80
                        });
                    }
                }, 500);
            }
        },

        async onSubmitCocolink() {
            this.errors = {};
            if (!this.request.cocolink_id) {
                this.idInput = true;
                return;
            }
            try {
                await this.$http.post("apply/cocolink/validate", {
                    cocolink_id: this.request.cocolink_id,
                })
                this.idInput = true;
            } catch (e) {
                const errors = e.response?.data?.errors;
                if (errors) {
                    this.errors = errors;
                } else {
                    this.$toastr.error('エラーが発生しました。');
                }
            }
        },

        async fetchUser() {
            try {
                const {data: {data}} = await this.$http.get('user');
                this.request.name1 = data.name1;
                this.request.name2 = data.name2;
            } catch (e) {
                this.$router.replace('/');
            }
        },

        async checkSession() {
            try {
                const {data: {data}} = await this.$http.get('user');
                return !!data;
            } catch (e) {
                this.$toastr.error('セッションが切れました。大変お手数ですが、再度やり直してください。');
                await this.$router.replace('/login');
                return false;
            }
        },
    }
}
</script>

<style scoped>

</style>
